export default "__VITE_ASSET__052c784c__"